(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["SemanticUiCalendarReact"] = factory();
	else
		root["SemanticUiCalendarReact"] = factory();
})(self, function() {
return 